// import { AjaxFetch, Ajax, RequestBuilder } from '@grammarly/http-clients'

// import { getConfig } from '../../../config'
// import { gnarClient } from '../../tracking/gnar'
// import { Cookie, getCookie } from '../../utils/cookies'
import { composeUrl, type OptionalQueryParams, type QueryParams } from '@lib/utils/url'

import { IS_BROWSER } from '@constants/globals'

// const config = getConfig()
// const baseUrl = config.urls.main
// const redirectApiUrl = config.api.redirect

class NavigationHelper {
  //   // #ToDo Temporary implementation, don't use in the server-side context
  get currentQueryParams(): QueryParams {
    if (!IS_BROWSER) {
      return {}
    }
    const urlObject = new URL(window.location.href)
    return [...urlObject.searchParams.entries()].reduce((acc, [key, value]) => {
      acc[key] = value
      return acc
    }, {} as QueryParams)
  }

  //   navigateFunnelPath = (path: string, queryParams: OptionalQueryParams = {}) => {
  //     return this.navigate(composeUrl(baseUrl + path, queryParams))
  //   }

  navigateUrl = (url: string, queryParams: OptionalQueryParams = {}) => {
    return this.navigate(composeUrl(url, queryParams))
  }

  //   navigateByRedirectService = (queryParams: OptionalQueryParams = {}) => {
  //     const state = this.currentQueryParams.state
  //     const queryWithState = {
  //       ...(queryParams ? queryParams : {}),
  //       ...(state ? { state } : {}),
  //     }
  //     return getRedirectLocation(queryWithState).then((url) => {
  //       this.navigate(url)
  //     })
  //   }

  private navigate = (fullUrl: string) => {
    window.location.assign(fullUrl)
  }
}

export const navHelper = new NavigationHelper()

// const getRedirectLocation = async (queryParams: OptionalQueryParams = {}) => {
//   const req = RequestBuilder.get(redirectApiUrl)
//   Object.keys(queryParams).forEach((key) => {
//     const queryValue = queryParams[key]
//     req.queryParam(key, queryValue ? queryValue.toString() : '')
//   })
//   await addApplicationRequestHeaders(req)
//   return sendRequest({}).text(req)
// }

// const sendRequest: Ajax.Factory<'Promise'> = AjaxFetch.create(fetch)

// const addApplicationRequestHeaders = async (req: RequestBuilder): Promise<void> => {
//   const headers = await getApplicationRequestHeaders()
//   Object.entries(headers).forEach(([name, value]) => req.header(name, value))
// }

// const getApplicationRequestHeaders = async () => {
//   const containerId = await gnarClient.getContainerId()
//   return {
//     'X-CSRF-Token': getCookie(Cookie.CsrfToken) || '',
//     'X-Client-Type': 'cms',
//     'X-Container-Id': containerId,
//   } as const
// }
